"use strict";
define(
    'stores/pins',[
        "jquery",
        "stores/store",
        "actions/boards",
        "constants/actiontypes",
        "shared/user",
        "xregexp"
    ],
    function ($, StoreBase, Action, Constants, User, XRegExp)
    {
        Store.prototype = new StoreBase();
        Store.constructor = Store;
        
		function Store (params) {
            // Call parent constructor
            StoreBase.call(this, params);

            // Setup the instance
            this.pins = {};

            this.registerDispatchListener(function (action) {
                switch(action.actionType) {
                    case Constants.ADD_PIN:
                        if (Array.isArray(action.data)) {
                            _.each(action.data, function (data, index, list) {
                                this.addPin(data);
                            }, this);
                        } else {
                            this.addPin(action.data);
                        }
                        this.event.emit("change");
                        break;
                }
            }.bind(this));

            this.action = new Action();
        }

		Store.prototype.addPin = function(data) {
            if(this.pins[data.id.toLowerCase()]) {
                delete this.pins[data.id.toLowerCase()];
            }
            
            data.created_at = new Date(data.created_at);
            data.updated_at = new Date(data.updated_at);
            this.pins[data.id.toLowerCase()] = data;
        };

        Store.prototype.getPin = function(id)
        {
            if(id && this.pins[id.toLowerCase()])
                return this.pins[id.toLowerCase()];
            return null;
        };
		return Store;
	}
);
